@if (!item.hidden) {
  <!-- collapsible title -->
  @if (!item.url) {
    <a
      class="d-flex align-items-center"
      [ngClass]="item.classes"
      (click)="toggleOpen($event)"
      [title]="item.title">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- itemContent template -->
  <ng-template #itemContent>
    @if (item.icon) {
      <love-it-generic-icon [selector]="item.icon"></love-it-generic-icon>
    }
    <span
      class="menu-title text-truncate"
      [translate]="item.translate"
      >{{ item.title }}</span
    >
    @if (item.badge) {
      <span
        class="badge ms-auto me-1"
        [translate]="item.badge.translate"
        [ngClass]="item.badge.classes">
        {{ item.badge.title }}
      </span>
    }
  </ng-template>
  <!-- sub-menu item/collapsible -->
  <ul class="menu-content">
    @for (item of item.children; track item) {
      <!-- item -->
      @if (item.type == "item" && checkPermission(item)) {
        <li
          core-menu-vertical-item
          [item]="item"
          [ngClass]="{ disabled: item.disabled === true, 'hide-mobile': !item.aufHandyAnzeigen }"
          [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
          <span
            [routerLink]="item.openInNewTab ? [] : [item.url]"
            class="d-none"></span>
        </li>
      }
      <!-- collapsible -->
      @if (item.type == "collapsible" && checkPermission(item)) {
        <li
          core-menu-vertical-collapsible
          [item]="item"
          class="nav-item has-sub"
          [ngClass]="{
            'hide-mobile': !item.aufHandyAnzeigen,
          }"></li>
      }
    }
  </ul>
}
